var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "videoPlayback-page" },
    [
      _vm.screenType == 0
        ? _c("div", { staticClass: "cross" })
        : _c(
            "div",
            { staticClass: "vertical" },
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "vertical-item",
                  on: {
                    click: function ($event) {
                      return _vm.clickItem(item)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "img-content" },
                    [
                      _c("van-image", {
                        staticClass: "img",
                        attrs: {
                          src: require("../../../../assets/themes/img/teasLogin/bg.jpg"),
                        },
                        on: { click: _vm.clickImg },
                      }),
                      _c(
                        "div",
                        { staticClass: "bofang" },
                        [_c("dsf-icon", { staticClass: "icon-ln_jiantouyou" })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s("校园景致")),
                  ]),
                ]
              )
            }),
            0
          ),
      _c(
        "van-popup",
        {
          staticClass: "videoPlayback-page-popup",
          attrs: {
            position: "center",
            "get-container": "#app",
            closeable: true,
          },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c("div", { staticClass: "video-content" }, [
            _c(
              "video",
              {
                staticClass: "video",
                attrs: { controls: "controls", autoplay: "autoplay" },
              },
              [
                _c("source", {
                  attrs: { src: "/i/movie.ogg", type: "video/ogg" },
                }),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }